// generated from 59_749 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const emailSubscriptionStatusFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("email_subscription_status_filter"),
  comparison_key: z.enum([
    "1", // 44_366 (74.25%)
    "2", // 15_383 (25.75%)
  ]),
  display_name: z.string(),
  // undefined: 18_210 (30.48%), defined 41_539 (69.52%)
  raw_value: common
    .numericEnum([
      2, // 17_158 (41.31%)
      0, // 14_583 (35.11%)
      1, // 9_798 (23.59%)
    ])
    .optional(),
  value: common.numericEnum([
    2, // 23_754 (39.76%)
    0, // 19_054 (31.89%)
    1, // 16_941 (28.35%)
  ]),
  varies_by_app_group: z.literal(false),
});
